import React from "react";
import Layout from "./Layout";
import { Shop } from "components/common/Card";
import helper from "utils/helper";

const ShopSection: React.FC<{
  title: string;
  description: string;
  data: any;
}> = ({ title, description, data }) => {
  // const { router } = useRouteContext();

  // const handler = {
  //   onShopClick: (item: { slug: string }) => {
  //     router.push(`/${item?.slug}`);
  //   },
  // };

  return (
    <Layout iconName="sun-fog" title={title} description={description}>
      <div className="flex gap-4 p-6 overflow-x-scroll scrollbar-hide h-full">
        {data?.map((item: any, idx: number) => (
          <div className="min-w-[300px] flex-shrink-0" key={idx}>
            <Shop
              className="h-full"
              {...helper.formatShop(item)}
              // onClick={() => handler.onShopClick(item)}
            />
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default ShopSection;
